import { ChatAI } from './chat-ai.model';
import { Coordinates } from './coordinates.model';
import { Doctor } from './doctor.model';
import { Patient } from './patient.model';
import { Specialty } from './specialty.model';

export class CallData {
  reason!: string;
  caller!: Patient;
  doctor: Doctor | null;
  records: string[];
  specialty!: Specialty | null;
  coordinates!: Coordinates;
  address?: string;
  reconnect?: boolean;
  chatAI: ChatAI | null;

  constructor(
    doctor: Doctor | null = null,
    specialty: Specialty | null = null,
    caller?: Patient,
    reason?: string,
    records?: string[],
    coordinates?: Coordinates,
    address?: string
  ) {
    this.doctor = doctor;
    if (specialty) this.specialty = specialty;
    if (reason) this.reason = reason;
    if (caller) this.caller = caller;
    if (coordinates) this.coordinates = coordinates;
    if (address) this.address = address;
    this.records = records || [];
    this.chatAI = null;
  }
}
